import React, { useCallback } from "react";
import { useFormContext } from "react-hook-form";

import { HookFormInputGroup } from "components/hookForms";
import { currencySixSigns, float6Normalizer, maxValue100 } from "validators";

import styles from "./feeTemplateField.module.scss";

type FeeTemplateFieldProps = {
	data: {
		name: string;
		displayName: string;
		sign?: string;
	};
	isLoading?: boolean;
	isPercent?: boolean;
};

const FeeTemplateField = ({
	data: { name, displayName, sign },
	isLoading,
	isPercent = false,
}: FeeTemplateFieldProps) => {
	const {
		register,
		formState: { errors },
	} = useFormContext();

	const normalize = useCallback((value: string) => {
		// Workaround to be able to drug&drop values from field to field
		const cleanStringArr = value?.split(" ");
		return currencySixSigns(
			cleanStringArr.length === 3 ? cleanStringArr[1] : cleanStringArr[0],
		);
	}, []);

	return (
		<HookFormInputGroup
			name={name}
			label={`${displayName},\u00A0${isPercent ? "%" : "$"}`}
			className={styles.fieldContainer}
			labelHtml={
				<>
					{`${displayName},\u00A0${isPercent ? "%" : "$"}`}
					{sign && <span className={styles.subLabel}>{sign}</span>}
				</>
			}
			register={register}
			errors={errors}
			placeholder="0.000000"
			normalize={normalize}
			normalizeOnBlur={value => float6Normalizer(value || 0)}
			validator={isPercent ? { maxValue100 } : undefined}
			blurLoading={isLoading}
		/>
	);
};

export default FeeTemplateField;
